import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import { isRuleNameValid, propertyFor } from '../utils/propertyRulesHelper';

import PropertyRule from './PropertyRule';
import { ListingSectionObservable } from './ListingSection';
import ListingTitle from './ListingTitle';
import DocumentsRequired from './DocumentsRequired';

import './PropertyRules.scss';

const Breaker = () => <div className="property-rules__breaker" />;

export const PropertyRules = ({
  landlordRules = null,
  landlordRulesInfo,
  landlordPolicies = '',
  cityId,
  countryCode
}) => (
  <ListingSectionObservable section="landlordRules">
    <ListingTitle role="secondary">
      {trans('property.rule.main.title')}
    </ListingTitle>
    {landlordRules && (
      <div className="property-rules__container" id="landlordRules">
        {Object.keys(landlordRules)
          .filter(rule => isRuleNameValid(rule, landlordRules))
          .map(rule => (
            <PropertyRule
              key={rule}
              ruleName={rule}
              info={landlordRulesInfo[rule]}
              ruleValue={landlordRules[rule]}
            />
          ))}
      </div>
    )}

    <DocumentsRequired
      cityId={cityId}
      countryCode={countryCode}
      onlyFor={propertyFor(landlordRules)}
    />

    {landlordPolicies && (
      <Fragment>
        <Breaker />
        <div className="property-rules__collapsible__container">
          <div className="property-rules__collapsible__description">
            <ListingTitle role="tertiary">
              {trans('property_show.title.landlord_policies')}
            </ListingTitle>
            <ListingContent content={landlordPolicies} />
          </div>
        </div>
      </Fragment>
    )}
  </ListingSectionObservable>
);

PropertyRules.propTypes = {
  cityId: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  landlordRules: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
    })
  }),
  landlordRulesInfo: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      value: PropTypes.string,
      additionalInfo: PropTypes.string
    })
  }).isRequired,
  landlordPolicies: PropTypes.string
};

export default PropertyRules;
